<template>
    <span class="fa-stack fa-1x">
        <i class="far fa-circle fa-stack-2x"></i>
      <strong class="fa-stack-1x circle-text">{{ number }}</strong>
    </span>
</template>

<script>
export default {
  name: 'NumberIcon',
  props: ['number'],
};
</script>
